module.exports = __webpack_public_path__ + "static/media/stopwatch-white.81652352.svg";